import { Capacitor } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'
import api from './api'

let tokenActual = null
let listenersListos = false

// Registra este dispositivo (app Android nativa) para recibir push vía FCM.
// No hace nada si se está corriendo en un navegador normal (web).
export async function suscribirFcm() {
  if (!Capacitor.isNativePlatform()) return

  const permiso = await PushNotifications.requestPermissions()
  if (permiso.receive !== 'granted') return

  if (!listenersListos) {
    listenersListos = true

    PushNotifications.addListener('registration', async ({ value: token }) => {
      tokenActual = token
      await api.post('/push/fcm-subscribe', { token }).catch(() => {})
    })

    PushNotifications.addListener('registrationError', (err) => {
      console.error('Error registrando FCM:', err)
    })

    // Notificación tocada por el usuario (app en background o cerrada) → navegar al chat
    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      const url = action.notification?.data?.url || '/inbox'
      window.location.href = url
    })
  }

  await PushNotifications.register()
}

// Da de baja el token FCM de este dispositivo (logout / opt-out)
export async function desuscribirFcm() {
  if (!Capacitor.isNativePlatform() || !tokenActual) return
  const authToken = localStorage.getItem('token')
  await api.post('/push/fcm-unsubscribe', { token: tokenActual }, {
    headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
  })
  tokenActual = null
}
